module.exports = __webpack_public_path__ + "img/footer-mari.26c1bac2.webp";